import axios from 'axios'
import { Message} from 'element-ui'
import cache from './cache'

import { getToken } from '@/utils/auth' // 验权token
const service = axios.create({
  baseURL: 'https://www.star-future.net/web_api', // 可根据实际情况调整
  timeout: 15000
})

// 请求拦截
service.interceptors.request.use(
    config => {
    
      const isToken = (config.headers || {}).isToken === false
     
      if (getToken() && !isToken) {
        config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
     const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
    // 可在此处添加token等公共header
     if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
    const requestObj = {
      url: config.url,
      data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
      time: new Date().getTime()
    }
    
    const sessionObj = cache.session.getJSON('sessionObj')
    if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
      cache.session.setJSON('sessionObj', requestObj)
    } else {
      const s_url = sessionObj.url;                  // 请求地址
      const s_data = sessionObj.data;                // 请求数据
      const s_time = sessionObj.time;                // 请求时间
      const interval = 1000;                         // 间隔时间(ms)，小于此时间视为重复提交
      if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
        const message = '数据正在处理，请勿重复提交';
        console.warn(`[${s_url}]: ` + message)
        return Promise.reject(new Error(message))
      } else {
        cache.session.setJSON('sessionObj', requestObj)
      }
    }
  }
    return config
  },
  
  error => {
    return Promise.reject(error)
  }

)

// 响应拦截
service.interceptors.response.use(

  response => {
  
   
    // 业务错误统一弹窗
    if (response.data && response.data.code && response.data.code !== 200) {
      Message.error(response.data.msg || 'Request error')
      return Promise.reject(response.data)
    }
    return response.data
  },
  error => {
 
    Message.error(error.message || 'Network error')
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js